import React from "react";
import {ThumbnailCarousel, ThumbnailCarouselProps} from "./ThumbnailCarousel";
import { ThumbnailCarouselItem } from "./ThumbnailCarouselItem";

import "./style/main.scss";

/**
 * A horizontal thumbnail picker
 * @param props 
 */
export const ScratchThumbnailCarousel:ThumbnailCarousel = (props:ThumbnailCarouselProps):JSX.Element => {

    if (props.prints.length < 2) { return <React.Fragment/> };

    return (
        <div className="ThumbnailCarousel">
            <div className="container">
                {props.prints.map((p, i) => {
                    return (
                        <ThumbnailCarouselItem
                            key={i}
                            index={i}
                            print={p}
                            selected={props.selected.indexOf(i) >= 0}
                            onToggled={()=>props.onToggleItem(i)}
                        />
                    )
                })}
            </div>
        </div>
    )

}